export const outboundConstants = {
    OUTBOUND_FETCHING: 'OUTBOUND_FETCHING',
    OUTBOUND_FETCHED: 'OUTBOUND_FETCHED',
    OUTBOUND_SUBMITTING: 'OUTBOUND_SUBMITTING',
    OUTBOUND_SUBMITTED: 'OUTBOUND_SUBMITTED',
    OUTBOUND_SUCCESS: 'OUTBOUND_SUCCESS',
    CLEAR_LOAD_LIST: 'CLEAR_LOAD_LIST',
    OUTBOUND_BOOKING_ATW: 'OUTBOUND_BOOKING_ATW',
    OUTBOUND_BOOKING_CBS: 'OUTBOUND_BOOKING_CBS',
    LOAD_CTS: 'LOAD_CTS',
    OUTBOUND_CTS: 'OUTBOUND_CTS',
    OUTBOUND_BOOKING_CTS: 'OUTBOUND_BOOKING_CTS',
    LOAD_WAYBILL: 'LOAD_WAYBILL',
    OUTBOUND_WAYBILL: 'OUTBOUND_WAYBILL',
    OUTBOUND_WAYBILL_TANDEM: 'OUTBOUND_WAYBILL_TANDEM',
    OUTBOUND_BOOKING_WAYBILL: 'OUTBOUND_BOOKING_WAYBILL',
    BUILD_UP: 'BUILD_UP',
    OUTBOUND_LOADLIST_RELEASE: 'OUTBOUND_LOADLIST_RELEASE',
    LOAD_LIST: 'LOAD_LIST',
    TALLY_SHEETS: 'TALLY_SHEETS',
    LIST_FOR_CREATE_TALLY_SHEET: 'LIST_FOR_CREATE_TALLY_SHEET',
    TALLY_SHEET: 'TALLY_SHEET',
    STOWAGE: 'STOWAGE',
    STOWAGE_FOR_CREATE: 'STOWAGE_FOR_CREATE',
    STOWAGE_CODE: 'STOWAGE_CODE',
    LOADING_CONFIRMATION: 'LOADING_CONFIRMATION',
    OUTBOUND_ALL_CTS: 'OUTBOUND_ALL_CTS',
    VOYAGE_BUILDUP_LIST: 'VOYAGE_BUILDUP_LIST',
    VOYAGE_LOAD_LIST: 'VOYAGELOAD__LIST',
    VOYAGE_TALLYSHEET_LIST: 'VOYAGE_L_TALLYSHEETIST',
    VOYAGE_STOWAGEPLAN_LIST: 'VO_STOWAGEPLANYAGE_LIST',
    VOYAGE_LOADING_CONFIRMATION_LIST: 'V_LOADING_CONFIRMATIONOYAGE_LIST',
    VOYAGE_WAYBILL_LIST: 'VOYAGE_WAYBILL_LIST',
    VOYAGE_REGUIDING_LIST: 'VOYAGE_REGUIDING_LIST',
    GET_REGUIDE_VOYAGE: 'GET_REGUIDE_VOYAGE',
    GET_VOYAGESCHEDULE_FOR_REGUIDE: 'GET_VOYAGESCHEDULE_FOR_REGUIDE',
    CLEAR_WAYBILL: 'CLEAR_WAYBILL',
    CLEAR_CREATION_TALLYSHEET: 'CLEAR_CREATION_TALLYSHEET',
    VOYAGE_CROACCTG_LIST: 'VOYAGE_CROACCTG_LIST',
    GET_CROACCTG_BY_VOYAGE: 'GET_CROACCTG_BY_VOYAGE',
    CLEAR_OUTBOUND: 'CLEAR_OUTBOUND',
    GET_WAYBILL_BY_VOYAGE_CRO_ACCOUNTING: 'GET_WAYBILL_BY_VOYAGE_CRO_ACCOUNTING',
    GET_WAYBILL_DATA_CRO_ACCOUTING: 'GET_WAYBILL_DATA_CRO_ACCOUTING',
    OUTBOUND_BOOKING_LIST: 'OUTBOUND_BOOKING_LIST',
    OUTBOUND_BOOKING_CTS_TANDEM: 'OUTBOUND_BOOKING_CTS_TANDEM',
    OUTBOUND_BOOKING_WAYBILL_TANDEM: 'OUTBOUND_BOOKING_WAYBILL_TANDEM',
    GET_VOYAGE_LOADING_REPORT: 'GET_VOYAGE_LOADING_REPORT',
    GET_VOYAGE_LOADING_REPORT_TALLYSHEET: 'GET_VOYAGE_LOADING_REPORT_TALLYSHEET',
    GET_PREVIOUS_VOYAGE: 'GET_PREVIOUS_VOYAGE',
    GET_DISPATCH_LIST: 'GET_DISPATCH_LIST',
    GET_ARCHIVE_DISPATCH_LIST: 'GET_ARCHIVE_DISPATCH_LIST',
    OUTBOUND_EXEMPTION_CHARGE: 'OUTBOUND_EXEMPTION_CHARGE',
    OUTBOUND_EXEMPTION_CHARGE_TANDEM: 'OUTBOUND_EXEMPTION_CHARGE_TANDEM',
    EXEMPTION_CHARGE_LOADING: 'EXEMPTION_CHARGE_LOADING',
    EXEMPTION_CHARGE_LOADED: 'EXEMPTION_CHARGE_LOADED',
    SEARCH_SI: 'SEARCH_SI',
}